export const MUTATION_TYPES = {
  RESET: 'reset',
};

export const ACTION_TYPES = {
  RESET: 'reset',
};
